import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  cookieLabel: {
    id: 'studio.zwurmB',
    defaultMessage: 'Cookie',
  },
  cookieHelp: {
    id: 'studio.PtjXAL',
    defaultMessage: 'The cookie for cookie authentication',
  },
  secretLabel: {
    id: 'studio.CtZMCP',
    defaultMessage: 'Secret',
  },
  secretHelp: {
    id: 'studio.OEa9Hi',
    defaultMessage: 'The secret for cookie authentication',
  },
});
